/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amarantos API
 * REST API for the Amarantos construction and infrastructure management platform. Supports both the Panel (web) and App (mobile) clients.
 *
 * OpenAPI spec version: 1.0.0
 */

export type NodeComponentCategory = typeof NodeComponentCategory[keyof typeof NodeComponentCategory];


export const NodeComponentCategory = {
  base: 'base',
  ring: 'ring',
  adjustment_ring: 'adjustment_ring',
  cover: 'cover',
  reducer: 'reducer',
} as const;
